<template>
  <div>
    <!-- <div class="pageDetail" v-if="detail"> -->
    <div v-if="detail">
      <!-- <div class="title">
        <div class="overall_topic">
          <span class="big_title">{{ detailData.title }}</span>
          <span class="time">{{ detailData.the_date }}</span>
        </div>
      </div> -->
      <!-- 详情页 -->
      <div v-if="detail">
        <div>
          <div v-html="detailData.content"></div>
          <div class="back" @click="back">返回</div>
        </div>
      </div>
    </div>

    <div class="pageList" v-if="list">
      <div class="ti_pic1">
        <img :src="newBanner" alt="" />
      </div>
      <!-- 一个标签在的地方 -->
      <div class="tabbar">
        <div class="c_title">
          <span class="c_tl">新闻资讯</span>
          <span class="e_tl">NEWS INFORMATION</span>
        </div>
        <div class="daohang">
          <div class="fenbu">
            <div
              v-for="item in data"
              :key="item.name"
              @click="handleNav(item)"
              :class="{ active: activeName == item.id }"
            >
              <span>{{ item.t_name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 行业动态 -->
      <div class="corporateNews">
        <div class="cn_juti">
          <div
            class="cn_box"
            v-for="item in pageData"
            :key="item.id"
            @click="clickBox(item)"
          >
            <div class="cn_pic">
              <img :src="item.show_img" alt="" />
            </div>
            <div class="cn_word">
              <div v-html="item.title"></div>
            </div>
            <div class="cn_time">
              <p>
                {{
                  item.the_date ? item.the_date : item.add_time.split(" ")[0]
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="block">
          <el-pagination
            :current-page="currentPage"
            :page-size="6"
            layout="pager"
            :total="total"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      activeName: "",
      data: "",
      currentPage: 1,
      detail: false,
      list: true,
      page: 1,
      total: 0,
      pageData: [],
      detailData: {},
      pdf: "",
      isPdf: false,
      newBanner: "",
    };
  },
  methods: {
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      this.currentPage = this.page;
      this.getNewsList(this.activeName);
    },
    handleNav(item) {
      this.activeName = item.id;
      this.getNewsList(item.id);
      this.handleCurrentChange(1);
      this.getNewsList(this.activeName);
    },
    clickBox(item) {
      if (item.cid == 27) {
        // window.open(item.logo, '_blank')
        window.parent.open(item.logo + "#toolbar=0", "_blank");
        return;
      }
      this.list = !this.list;
      this.detail = !this.detail;
      this.detailData = item;
    },
    back() {
      this.list = !this.list;
      this.detail = !this.detail;
      this.currentPage = this.page;
    },
    getNewsList(cid = 15) {
      axios({
        url:
          this.base_url.base_url +
          "/index.php/index/index/news_list?nid=12&cid=" +
          cid,
        method: "get",
        params: {
          page: this.page,
          limit: 6,
        },
      })
        .then((res) => {
          this.pageData = res.data.data.news_data;
          this.total = res.data.data.news_count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPageData() {
      axios({
        url: this.base_url.base_url + "/index.php/index/index/navigation_list",
        method: "get",
      })
        .then((res) => {
          this.data = res.data.data.bottom_list[3].child;
          this.newBanner = res.data.data.top_list[3].banner_list[0].img;
          if (this.$route.query.id) {
            // 如果有id 判断
            this.data.forEach((v) => {
              if (v.id == this.$route.query.id) {
                this.activeName = v.id;
                this.getNewsList(v.id);
              }
            });
          } else {
            // 如果没有id 默认第一个
            this.activeName = this.data[0].id;
            this.getNewsList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getPageData();
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 1920px) {
  .nr {
    width: 1737px !important;

    :deep(p) {
      width: 1737px;

      img {
        width: 1737px !important;
      }
    }
  }
}

/* 一个因为不会用element写被迫手搓标签页的小可怜 */
.tabbar {
  display: flex;
  justify-content: space-between;

  .daohang {
    width: 375px;
    height: 42px;
    /* float: right; */
  }
}

.pageDetail {
  padding: 40px 60px;
  height: 100%;

  .nr {
    height: 100%;
    text-align: center;
    width: 1920px;
    margin: 0 auto;
    overflow: auto;

    :deep(p) {
      img {
        float: none !important;
      }
    }
  }
}

.back {
  width: 1306px;
  height: 60px;
  margin: 30px auto 40px;
  background-color: #f4f8fb;
  text-align: center;
  line-height: 60px;
  cursor: pointer;
}

.daohang .fenbu {
  display: flex;

  div {
    width: 125px;
    height: 42px;
    text-align: center;
    line-height: 42px;
    cursor: pointer;
  }
}

.active {
  background-color: #234ce2;
  color: #fff;
}

/* 一个 */
.title {
  width: 100%;
  height: 200px;
  padding: 50px 0;
  background: #f7f8fa;
}

.overall_topic {
  width: 800px;
  height: 200px;
  line-height: 100px;
  text-align: left;
  margin: 0 auto;
}

.big_title {
  width: 699px;
  height: 36px;
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: 800;
  color: #333333;
  // line-height: 60px;
}

.time {
  width: 150px;
  height: 14px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 800;
  color: #666666;
}

.neirong2 {
  width: 980px;
  height: 500px;
  margin: 0 auto;
  text-align: center;
  // transform: scale(.7);
  margin-bottom: -680px;
  margin-top: -670px;
}

.neirong2 p {
  text-align: left;
}

.huiyi {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-bottom: 30px;
}

.wenzi {
  /* width: 710px; */
  /* height: 38px; */
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #333333;
  line-height: 24px;
  margin-bottom: 10px;
}

.wenzi p {
  width: 955px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-bottom: 20px;
}

.footer {
  margin-top: -150px;
}

.pic_1 {
  width: 100%;
}

.pic_1 img {
  width: 100%;
  height: 683px;
}

.pic_2 {
  width: 100%;
}

.pic_2 img {
  width: 100%;
  /* height: 1713px; */
}

.pic_4 {
  margin-top: 40px;
}

.fanye {
  width: 100%;
  height: 97px;
  background: #f7f8fa;
  border-top: 1px solid#aaaaabFF;
  margin-bottom: -70px;
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.fanye span {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}

/* 一个标签在的地方 */
.tabbar {
  width: 1646px;

  margin: 30px auto;
  transform: scale(0.8);
}

.c_tl:before {
  content: "";
  width: 3px;
  height: 31px;
  background: #234ce2;
  position: absolute;
  top: 10px;
  left: -10px;
}

.c_tl {
  width: 133px;
  height: 32px;
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  position: relative;
  margin-left: 10px;
}

/* second */
.ti_pic1 img {
  width: 100%;
}

.corporateNews {
  width: 1319px;
  margin: 0 auto;
  margin-bottom: 90px;
  // transform: scale(0.8);
  // margin-top: -95px;

  .cn_juti {
    width: 1319px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 40px;
    cursor: pointer;

    .cn_box {
      box-sizing: border-box;
      width: 431px;
      height: 411px;
      // position: relative;
      border-bottom: 1px solid #3e3a39;
      cursor: pointer;
      margin-right: 13px;
      margin-bottom: 75px;
      display: flex;
      flex-direction: column;

      /* height: 260px; */
      .cn_pic {
        width: 431px;
        height: 260px;
        margin-bottom: 20px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .cn_word {
        padding: 0 20px 0px;
        flex: 1;

        font-size: 18px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
      }

      .cn_time {
        padding: 0 20px 20px;

        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #8d8c8c;
      }
    }

    :nth-child(3n) {
      margin-right: 0px;
    }
  }

  .cn_box:hover {
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid #234ce2ff;
  }
}

/* 分页 */
.block {
  margin-top: 60px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-pagination {
  font-weight: 400;
}

.block span {
  font-size: 12px;
  width: 35.5px !important;
  height: 35.5px !important;
  line-height: 35px !important;
  text-align: center !important;
}

.el-pagination .btn-prev .el-icon {
  width: 35.5px !important;
  height: 35.5px !important;
  line-height: 35px !important;
  text-align: center !important;
  font-weight: 400 !important;
  padding-right: 20px;
}

.el-pagination .btn-prev .el-icon:hover {
  color: #234ce2 !important;
}

.el-pagination .btn-next .el-icon {
  font-size: 12px;
  width: 35.5px !important;
  height: 35.5px !important;
  line-height: 35px !important;
  text-align: center !important;
  font-weight: 400 !important;
  padding-left: 20px;
}

.el-pagination .btn-next .el-icon:hover {
  color: #234ce2 !important;
}

::v-deep {
  .el-pager {
    .number {
      width: 35px;
      height: 35px;
      border: 1px solid #000 !important;
      border-radius: 50%;
      line-height: 32px;
      margin-right: 10px;
      cursor: pointer;

      &.active {
        background-color: #234ce2;
        color: #fff;
      }
    }
  }
}

.el-pager li {
  font-weight: 400;
  width: 35.5px !important;
  height: 35.5px !important;
  line-height: 35px !important;
  text-align: center !important;
  border: 1px solid #000 !important;
}

.el-pager li.active {
  /* width: 35.5px !important;
  height: 35.5px !important; */
  /* text-align: center !important;
  line-height:35px !important; */
  border-radius: 35px !important;
  border: 1px solid #234ce2 !important;
  color: #234ce2 !important;
}

.el-pager li:hover {
  color: #234ce2 !important;
}

/* second */
</style>
